import { makeStyles } from "@material-ui/core/styles";

const useStyles = makeStyles((theme) => ({
  tableFilterBtn: {
    textTransform: "none",
    fontWeight: "bold",
  },
  filter: {
    display: "inline-block",
    marginLeft: 10,
    [theme.breakpoints.down("sm")]: {
      marginLeft: 0,
    },
  },
  filterRight: {
    display: "inline-block",
    marginLeft: 10,
    textAlign: "right",
  },
  filterAddon: {
    display: "inline-block",
    marginLeft: 10,
    [theme.breakpoints.down("sm")]: {
      width: "100%",
      marginTop: 5,
    },
  },
  filterTooltip: {
    zIndex: 3,
  },
  filterPopper: {
    width: "100%",
    maxWidth: 420,
    minWidth: 300,
    padding: 12,
  },
  filterPopperContainer: {
    maxWidth: 420,
    minWidth: 420,
    padding: 12,
    paddingTop: 20,
    paddingBottom: 20,
    [theme.breakpoints.down("sm")]: {
      padding: "16px !important",
      minWidth: 360,
    },
    [theme.breakpoints.down("xs")]: {
      padding: "16px !important",
      minWidth: 300,
    },
  },
  filterBreakdownPopperContainer: {
    maxWidth: 200,
    minWidth: 200,
    padding: 12,
    paddingTop: 20,
    paddingBottom: 20,
    [theme.breakpoints.down("sm")]: {
      padding: "30px !important",
      minWidth: "auto",
    },
  },
  filterDivider: {
    borderTop: "solid 1px #f8f8f8",
  },
  filterActions: {
    display: "flex",
  },
  filterActionsRight: {
    flex: "1 1",
    textAlign: "right",
  },
  filterActionBtn: {
    display: "inline-block",
    marginLeft: 10,
    padding: "0px 6px",
    fontSize: "0.7rem",
    fontWeight: "bold",
  },
  filterActionBtnLeft: {
    display: "inline-block",
    padding: "0px 6px",
    fontSize: "0.7rem",
    fontWeight: "bold",
  },
  filterCheck: {
    padding: "0 5px 0 0",
  },
  filterLabel: {
    fontSize: "14px",
  },
  filterGroup: {
    borderBottom: "solid 1px #f8f8f8",
    paddingBottom: 10,
    marginBottom: 10,
    width: "100%",
  },
  filtersApplied: {
    display: "inline-block",
    marginBottom: 10,
    fontSize: 14,
    textAlign: "right",
    marginTop: 4,
  },
  filterChip: {
    fontSize: 12,
    marginLeft: 10,
    marginBottom: 3,
  },
  titleFilter: {
    fontSize: 14,
    paddingTop: theme.spacing(1),
  },
  filterCheckbox: {
    color: "#ececec",
    border: "none",
    padding: 0,
    paddingRight: 5,
    "& + .MuiFormControlLabel-label": {
      fontSize: 14,
    },
  },
  filterCheckboxAddon: {
    color: "#ececec",
    border: "none",
    padding: 0,
    paddingRight: 5,
    "& + .MuiFormControlLabel-label": {
      fontSize: "0.875rem",
      fontWeight: "bold",
    },
  },
  autoContainerFilter: {
    "&  label": {
      display: "none",
    },
    "& > div": {
      marginBottom: 0,
    },
  },
  wrapperTeamMember: {
    "& > div": {
      marginBottom: 0,
    },
  },
  tableOptionBtn: {
    maxWidth: 60,
    paddingTop: 8,
    paddingBottom: 8,
  },
  titleOptionsKpi: {
    "& div": {
      minWidth: 40,
    },
    "& span": {
      fontSize: 14,
      fontWeight: 600,
    },
    "& svg": {
      fontSize: 24,
    },
  },
  filterBreakdownItem: {
    paddingLeft: 16,
    paddingRight: 16,
    paddingBottom: 8,
  },
  btnSettings: {
    textTransform: "none",
  },
}));

export default useStyles;
